import { PauseIcon } from "@images/svgIcons/pauseIcon"
import { PlayIcon } from "@images/svgIcons/playIcon"
import { ThrophIcon } from "@images/svgIcons/throphIcon"
import { ProgramProgressionStatus } from "@modules/programs/programOnOffTypes"

export function getProgramProgressionStatusIcon(status: ProgramProgressionStatus, color: string): React.JSX.Element {
  switch (status) {
    case ProgramProgressionStatus.NOT_STARTED:
      return <></>
    case ProgramProgressionStatus.STARTED:
      return <PlayIcon color={color} width={24} height={24}/>
    case ProgramProgressionStatus.STOPPED:
      return <PauseIcon color={color} width={24} height={24} />
    case ProgramProgressionStatus.COMPLETED:
      return <ThrophIcon color={color} width={24} height={24} />
    default:
      return <></>
  }
}
